import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@node_modules/@angular/forms';
import {User} from '@models/user';
import {Store} from '@node_modules/@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import {AuthFacade} from '@facades/auth/authFacade';
import {CurriculumService} from '@services/curriculum/curriculum.service';
import {Curriculum} from '@models/curriculum';
import * as ProgramReducer from '@store/program/reducers';
import {AddCurriculumToProgram, UpdateCurriculum} from '@store/program/actions';
import {Program} from '@models/program';
import {AngularEditorConfig} from '@node_modules/@kolkov/angular-editor';
import {MessagePageComponent} from '@pages/layout/messages/message-page/message-page.component';

@Component({
  selector: 'app-create-program-curriculum',
  templateUrl: './create-program-curriculum.component.html',
  styleUrls: ['./create-program-curriculum.component.scss']
})
export class CreateProgramCurriculumComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() program: Program;

  /**
   * (649) Template reference to the .mkc-editor-wrapper div.
   * Used to scope DOM queries for the Angular Editor's internal file input
   * to this component only — avoids a global document.querySelector.
   */
  @ViewChild('editorWrapper') editorWrapper: ElementRef;
  static source = 'curriculum';
  static isEdit = false;
  static editingItem;
  static modalRef;
  static parent_id;
  previous_id;
  crateCurriculumForm: FormGroup;
  source: string;
  subscribes = [];
  user: User;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '17rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    uploadUrl: 'image',
    customClasses: [ // optional
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
      {
        name: "floatRight",
        class: "floatRight",
      },
      {
        name: "floatLeft",
        class: "floatLeft",
      },
    ]
  };

  constructor(
    private curriculumService: CurriculumService,
    private authStore: Store<AuthReducer.AuthState>,
    private programStore: Store<ProgramReducer.ProgramState>
  ) {
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        const user = AuthFacade.getUser();
        // console.log(user);
        if (user) {
          this.user = user;
        }
      }
    ));
  }

  ngOnInit() {
    console.log(this);
    this.source = CreateProgramCurriculumComponent.source;
    this.crateCurriculumForm = new FormGroup({
      'name': new FormControl(CreateProgramCurriculumComponent.editingItem ? CreateProgramCurriculumComponent.editingItem.name : null, [Validators.required, Validators.maxLength(190), Validators.minLength(3)]),
      'description': new FormControl(CreateProgramCurriculumComponent.editingItem ? CreateProgramCurriculumComponent.editingItem.description : null, [Validators.required, Validators.minLength(3)]),
      'owner': new FormControl(this.user.id, [Validators.required]),
    });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      MessagePageComponent.setUpEditor();
    }, 15);
  }
  ngOnDestroy() {
    this.subscribes.map(subscr => subscr.unsubscribe());
    if (this.imagePanelObserver) { this.imagePanelObserver.disconnect(); this.imagePanelObserver = null; }
  }
  onCreate() {
    let body = {
      'name': this.crateCurriculumForm.get('name').value,
      'description': this.crateCurriculumForm.get('description').value,
      'previous_id': this.previous_id,
    };
    console.log(body);
    console.log(this.previous_id, 'this.previous_id');
    if (CreateProgramCurriculumComponent.isEdit === true && CreateProgramCurriculumComponent.editingItem && CreateProgramCurriculumComponent.editingItem.id) {
      body['id'] = CreateProgramCurriculumComponent.editingItem.id
    }
    this.curriculumService.create(body, CreateProgramCurriculumComponent.source, CreateProgramCurriculumComponent.parent_id).subscribe(
      (resp: {data: Curriculum}) => {
        // console.log(resp);
        if (CreateProgramCurriculumComponent.source !== 'curriculum') {
          this.programStore.dispatch(new UpdateCurriculum({curriculum: resp.data, program_id: null}));
        } else {
          this.programStore.dispatch(new AddCurriculumToProgram({curriculum: resp.data, program_id: null, deleted: false}));
        }

        if (CreateProgramCurriculumComponent.modalRef) {
          CreateProgramCurriculumComponent.modalRef.close()
        }
      });
  }

  cancel() {
    if (CreateProgramCurriculumComponent.modalRef) {
      CreateProgramCurriculumComponent.modalRef.close()
    }
  }
  isAddCurriculum() {
    return CreateProgramCurriculumComponent.source === 'curriculum';
  }
  isAddLesson() {
    return CreateProgramCurriculumComponent.source === 'lesson';
  }
  isAddBlock() {
    return CreateProgramCurriculumComponent.source === 'block';
  }
  isEditing() {
    return CreateProgramCurriculumComponent.isEdit;
  }
  firstCharUpperCase(string) {
    return string[0].toUpperCase() + string.substring(1);
  }

  // ── (646/649/659) Editor action row state ────────────────────────────────

  /** Whether the Angular Editor toolbar is currently visible. Default hidden. */
  isTextToolbarOpen = false;

  /** (659/664) Image insert panel state. imageSize default: 'small'. imageLayout default: 'center'. */
  imagePanel: {open: boolean; imageSize: string; imageLayout: string} = {open: false, imageSize: 'small', imageLayout: 'center'};

  /** (659) MutationObserver used to detect img inserted by Angular Editor. Cleaned up on destroy. */
  private imagePanelObserver: MutationObserver | null = null;

  /**
   * Whether the fallback image hint paragraph is visible.
   * Only shown when the direct file-input trigger fails (e.g. input not found).
   */
  showImageHint = false;

  /** (666) Editable helper text inserted alongside media. User can edit or delete freely. */
  private readonly mediaHelperHtml =
    '<div class="mkc-media-helper-text">' +
    '<p>Replace this text with your own</p>' +
    '<ul>' +
    '<li>Write your bullet points</li>' +
    '<li>You can also remove bullet points</li>' +
    '<li>You can use numbered rows</li>' +
    '<li>Or just delete everything and format as you wish</li>' +
    '</ul>' +
    '</div>' +
    '<div class="mkc-media-clearfix"></div>';

  /**
   * (649) Text Editor toggle — opens or closes the Angular Editor toolbar.
   * Opening: also closes video panel and resets image active state.
   * Closing: resets hint only; image/video state already clean.
   */
  toggleTextToolbar(): void {
    this.isTextToolbarOpen = !this.isTextToolbarOpen;
    if (this.isTextToolbarOpen) {
      // Opening: close sibling actions
      if (this.videoPanel.open) { this.closeVideoPanel(); }
      if (this.imagePanel.open) { this.closeImagePanel(); }
    } else {
      this.showImageHint = false;
    }
  }

  /**
   * (674) Applies a text format command without stealing focus/selection.
   * mousedown.preventDefault() on the caller prevents the button from taking
   * focus away from the contenteditable, keeping the active selection intact.
   * execCommand then runs on the still-focused editor with the selection preserved.
   *
   * Used for: Normal (formatBlock p), Heading (formatBlock h2),
   *   Subheading (formatBlock h3), Bold, Italic,
   *   Bullet List (insertUnorderedList), Numbered List (insertOrderedList).
   */
  applyTextCommand(event: MouseEvent, command: string, value?: string): void {
    event.preventDefault();
    try {
      document.execCommand(command, false, value || null);
    } catch (e) { /* ignore — execCommand may throw in some browsers */ }
  }

  /**
   * (674) Inserts a full-width horizontal divider at the current cursor position.
   * Captures the active selection before the button's mousedown can steal focus,
   * then uses insertHtmlIntoEditor so the HTML goes at cursor (not appended).
   * The divider uses clear:both so it escapes any floated media column.
   * A trailing <p><br></p> leaves the cursor in a clean paragraph after the rule.
   */
  insertDivider(event: MouseEvent): void {
    event.preventDefault();
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
      this.savedRange = sel.getRangeAt(0).cloneRange();
    }
    const html =
      '<div class="mkc-divider-block">' +
      '<hr class="mkc-content-divider">' +
      '</div>' +
      '<p><br></p>';
    this.insertHtmlIntoEditor(html);
    this.savedRange = null;
  }

  /**
   * (677) Current alignment state for the single cycle-alignment toolbar button.
   * Starts as 'left' each time the modal opens (no queryCommandState tracking).
   * Value reflects what was last applied, not necessarily the true browser state.
   */
  textAlignmentMode: 'left' | 'center' | 'right' | 'justify' = 'left';

  /**
   * (677) Cycles text alignment Left → Center → Right → Justify → Left on each press.
   * mousedown.preventDefault() preserves editor focus/selection before execCommand runs.
   * Updates textAlignmentMode so the button label reflects the newly applied alignment.
   */
  cycleTextAlignment(event: MouseEvent): void {
    event.preventDefault();
    const order: Array<'left' | 'center' | 'right' | 'justify'> = ['left', 'center', 'right', 'justify'];
    const nextMode = order[(order.indexOf(this.textAlignmentMode) + 1) % order.length];
    this.textAlignmentMode = nextMode;
    const commandMap: {[key: string]: string} = {
      left:    'justifyLeft',
      center:  'justifyCenter',
      right:   'justifyRight',
      justify: 'justifyFull',
    };
    try {
      document.execCommand(commandMap[nextMode], false, null);
    } catch (e) { /* ignore */ }
  }

  /** (677) Returns a readable label for the current alignment state, shown on the toolbar button. */
  getTextAlignmentLabel(): string {
    const labels: {[key: string]: string} = {
      left:    'Left',
      center:  'Center',
      right:   'Right',
      justify: 'Justify',
    };
    return labels[this.textAlignmentMode] || 'Left';
  }

  /**
   * (659) Add Image toggle — opens or closes the image insert panel.
   * Opening: closes video panel if open. Does NOT force-close text toolbar.
   */
  toggleImagePanel(): void {
    if (this.imagePanel.open) {
      this.closeImagePanel();
      return;
    }
    // Opening
    if (this.videoPanel.open) { this.closeVideoPanel(); }
    this.showImageHint = false;
    this.imagePanel = {open: true, imageSize: 'small', imageLayout: 'center'};
  }

  /** (659) Resets image panel to closed/default state and disconnects any live observer. */
  closeImagePanel(): void {
    this.imagePanel = {open: false, imageSize: 'small', imageLayout: 'center'};
    this.showImageHint = false;
    if (this.imagePanelObserver) { this.imagePanelObserver.disconnect(); this.imagePanelObserver = null; }
  }

  /**
   * (659) "Choose Image" — triggered from inside the image panel.
   *
   * Preferred path:
   *   1. Starts a scoped MutationObserver on editorWrapper watching for new <img> elements.
   *   2. Clicks the Angular Editor's hidden file input (scoped to this component via @ViewChild).
   *   3. After upload completes, editor calls execCommand('insertHTML', '<img src="...">').
   *      The observer detects the new <img> and adds mkc-editor-image + mkc-editor-image--{size}.
   *   4. Observer disconnects after first match or 30 s safety timeout.
   *
   * Fallback path (file input not found): opens toolbar + shows hint paragraph.
   *
   * MutationObserver callbacks run outside Angular's zone — only DOM class mutations,
   * so no change detection is needed there.
   */
  chooseImage(): void {
    const size = this.imagePanel.imageSize || 'small';
    const layout = this.imagePanel.imageLayout || 'center';
    let triggered = false;

    try {
      const wrapper = this.editorWrapper && this.editorWrapper.nativeElement;
      if (wrapper) {
        const fileInput = wrapper.querySelector('input[type="file"][accept="image/*"]') as HTMLInputElement;
        if (fileInput) {
          // Set up observer BEFORE click so insertion is caught even if upload is fast
          if (this.imagePanelObserver) { this.imagePanelObserver.disconnect(); this.imagePanelObserver = null; }

          const applyClass = (img: Element) => {
            // Remove any stale layout classes before applying fresh ones
            img.classList.remove('mkc-media-layout--center', 'mkc-media-layout--left', 'mkc-media-layout--right');
            if (!img.classList.contains('mkc-editor-image')) {
              img.classList.add('mkc-editor-image', `mkc-editor-image--${size}`);
            }
            img.classList.add('mkc-media-layout', `mkc-media-layout--${layout}`);
          };

          this.imagePanelObserver = new MutationObserver((mutations) => {
            let found = false;
            for (const mutation of mutations) {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeName === 'IMG') {
                  applyClass(node as Element);
                  found = true;
                }
                if ((node as Element).querySelectorAll) {
                  (node as Element).querySelectorAll('img').forEach((img) => { applyClass(img); found = true; });
                }
              });
            }
            if (found) {
              if (this.imagePanelObserver) {
                this.imagePanelObserver.disconnect();
                this.imagePanelObserver = null;
              }
              // Insert helper text at the cursor position, which is right after the
              // newly inserted img. setTimeout runs inside Angular's zone (Zone.js
              // patches setTimeout), so the editor's 'input' event fires in-zone and
              // the reactive FormControl value updates automatically.
              //
              // (669) Append <p><br></p> after the helper text so the cursor lands
              // in a clean empty paragraph outside the media block. Without this,
              // the cursor can end up inside the clearfix div, and the next image
              // insert (via Angular Editor) goes there rather than starting fresh.
              setTimeout(() => {
                try {
                  const editorTextarea = wrapper.querySelector('.angular-editor-textarea') as HTMLElement;
                  if (editorTextarea) {
                    editorTextarea.focus();
                    document.execCommand('insertHTML', false, this.mediaHelperHtml + '<p><br></p>');
                  }
                } catch (e) { /* ignore */ }
              }, 0);
            }
          });

          this.imagePanelObserver.observe(wrapper, {childList: true, subtree: true});

          // Safety timeout — disconnect after 30 s if no img detected
          const obs = this.imagePanelObserver;
          setTimeout(() => {
            if (obs) { obs.disconnect(); }
            if (this.imagePanelObserver === obs) { this.imagePanelObserver = null; }
          }, 30000);

          fileInput.click();
          triggered = true;
          // (666) Panel intentionally NOT closed here. The observer must stay alive
          // until the HTTP upload completes and Angular Editor inserts the <img>.
          // closeImagePanel() disconnects the observer — calling it here was the root
          // cause of layout classes never being applied. Panel stays open; user closes
          // it manually via the X, Cancel, or by clicking Add Image again.
        }
      }
    } catch (e) { /* fall through to fallback */ }

    if (!triggered) {
      // Fallback: reveal toolbar so user can access the image button manually
      this.closeImagePanel();
      this.isTextToolbarOpen = true;
      this.showImageHint = true;
    }
  }

  // ── (642/646) Video insert panel ──────────────────────────────────────────

  /** Transient UI state for the inline video insert panel. */
  videoPanel: {open: boolean; mode: string; urlValue: string; embedValue: string; videoSize: string; videoLayout: string; error: string} = {
    open: false,
    mode: 'url',
    urlValue: '',
    embedValue: '',
    videoSize: 'medium',
    videoLayout: 'center',
    error: '',
  };

  /** Selection range captured on mousedown before the editor loses focus. */
  private savedRange: Range | null = null;

  /**
   * Called on mousedown of the "Add Video" button.
   * event.preventDefault() keeps editor focus & selection so we can
   * restore and insert at cursor later. The click event still fires.
   */
  onAddVideoBtnMousedown(event: MouseEvent): void {
    event.preventDefault();
    const sel = window.getSelection();
    this.savedRange = (sel && sel.rangeCount > 0) ? sel.getRangeAt(0).cloneRange() : null;
  }

  /**
   * (649) Add Video toggle — press once to open, press again to close.
   * Preserves the mousedown cursor/range save: onAddVideoBtnMousedown fires
   * before this click handler, so savedRange is already captured when we open.
   * Opening: closes image active state. Does NOT force-close text toolbar.
   */
  toggleVideoPanel(): void {
    if (this.videoPanel.open) {
      this.closeVideoPanel();
      return;
    }
    // Opening
    if (this.imagePanel.open) { this.closeImagePanel(); }
    this.openVideoPanel();
  }

  openVideoPanel(): void {
    this.showImageHint = false;
    this.videoPanel = {open: true, mode: 'url', urlValue: '', embedValue: '', videoSize: 'medium', videoLayout: 'center', error: ''};
  }

  closeVideoPanel(): void {
    this.videoPanel = {open: false, mode: 'url', urlValue: '', embedValue: '', videoSize: 'medium', videoLayout: 'center', error: ''};
    this.savedRange = null;
  }

  /** True when the Insert Video button should be disabled. */
  isVideoInsertDisabled(): boolean {
    if (this.videoPanel.mode === 'url') {
      return !(this.videoPanel.urlValue || '').trim();
    }
    return !(this.videoPanel.embedValue || '').trim();
  }

  insertVideo(): void {
    this.videoPanel.error = '';
    let html: string;

    if (this.videoPanel.mode === 'url') {
      const url = (this.videoPanel.urlValue || '').trim();
      if (!url) {
        this.videoPanel.error = 'Please enter a video URL.';
        return;
      }
      html = this.buildVideoHtmlFromUrl(url);
      if (!html) {
        this.videoPanel.error = 'URL not recognised. Supported: YouTube and Vimeo.';
        return;
      }
    } else {
      const embedCode = (this.videoPanel.embedValue || '').trim();
      if (!embedCode) {
        this.videoPanel.error = 'Please paste embed code.';
        return;
      }
      html = this.buildVideoHtmlFromEmbed(embedCode);
      if (!html) {
        this.videoPanel.error = 'No valid iframe src found. Paste the full embed code from YouTube or Vimeo.';
        return;
      }
    }

    this.insertHtmlIntoEditor(html);
    // (666) Panel stays open after insert so user can add another video.
    // Clear input fields and error; preserve selected size/layout for re-use.
    this.videoPanel.urlValue = '';
    this.videoPanel.embedValue = '';
    this.videoPanel.error = '';
    this.savedRange = null;
  }

  /**
   * Inserts HTML at the saved cursor position if available,
   * otherwise appends it to the current description value.
   */
  private insertHtmlIntoEditor(html: string): void {
    const descCtrl = this.crateCurriculumForm.get('description');

    if (this.savedRange) {
      try {
        // Re-focus the editor's contenteditable and restore the selection.
        const editorEl = document.querySelector('.angular-editor-textarea') as HTMLElement;
        if (editorEl) {
          editorEl.focus();
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(this.savedRange);
          // insertHTML triggers the editor's 'input' event, which propagates
          // the new value to the reactive FormControl automatically.
          document.execCommand('insertHTML', false, html);
          descCtrl.markAsDirty();
          descCtrl.markAsTouched();
          return;
        }
      } catch (e) {
        // Fall through to append fallback.
      }
    }

    // Fallback: append video to the end of the current description.
    const current = (descCtrl.value || '') as string;
    descCtrl.setValue(current + html);
    descCtrl.markAsDirty();
    descCtrl.markAsTouched();
  }

  private buildVideoHtmlFromUrl(url: string): string {
    const embedSrc = this.resolveVideoEmbedSrc(url);
    return embedSrc ? this.wrapIframe(embedSrc) : '';
  }

  /**
   * Parses YouTube and Vimeo URL formats and returns a clean embed src.
   * Supported:
   *   YouTube: watch?v=, youtu.be/, embed/, shorts/
   *   Vimeo:   vimeo.com/{id}, player.vimeo.com/video/{id}
   */
  private resolveVideoEmbedSrc(url: string): string | null {
    // YouTube watch?v=
    const ytWatch = url.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (ytWatch) { return `https://www.youtube.com/embed/${ytWatch[1]}`; }

    // YouTube youtu.be/
    const ytShort = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (ytShort) { return `https://www.youtube.com/embed/${ytShort[1]}`; }

    // YouTube /embed/ (already canonical)
    const ytEmbed = url.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
    if (ytEmbed) { return `https://www.youtube.com/embed/${ytEmbed[1]}`; }

    // YouTube /shorts/
    const ytShortsPath = url.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
    if (ytShortsPath) { return `https://www.youtube.com/embed/${ytShortsPath[1]}`; }

    // Vimeo standard: vimeo.com/{id}
    const vimeoStd = url.match(/(?:^|[^a-z])vimeo\.com\/(\d+)/);
    if (vimeoStd) { return `https://player.vimeo.com/video/${vimeoStd[1]}`; }

    // Vimeo player: player.vimeo.com/video/{id} (already canonical)
    const vimeoPlayer = url.match(/player\.vimeo\.com\/video\/(\d+)/);
    if (vimeoPlayer) { return `https://player.vimeo.com/video/${vimeoPlayer[1]}`; }

    return null;
  }

  /**
   * Accepts raw embed code (e.g. from YouTube/Vimeo share dialog).
   * Extracts the src from the first iframe found. Rejects any code
   * containing <script tags. Returns empty string if invalid.
   */
  private buildVideoHtmlFromEmbed(embedCode: string): string {
    // Reject embed codes containing script elements.
    if (/<script/i.test(embedCode)) { return ''; }

    // Extract iframe src — must be http or https.
    const srcMatch = embedCode.match(/src=["'](https?:\/\/[^"']+)["']/i);
    if (!srcMatch) { return ''; }

    return this.wrapIframe(srcMatch[1]);
  }

  /**
   * Wraps a video embed src in a responsive 16:9 iframe container.
   * (646) Appends a size modifier class based on the current videoPanel.videoSize.
   *   small  → mkc-video-wrapper--small  (max-width ~520px)
   *   medium → mkc-video-wrapper--medium (max-width ~760px, default)
   *   large  → mkc-video-wrapper--large  (max-width 100%)
   * Existing saved videos with only class="mkc-video-wrapper" behave as medium
   * via the CSS fallback rule.
   * (664) Appends layout class based on the current videoPanel.videoLayout.
   *   center → mkc-media-layout--center  (float none, margin auto)
   *   left   → mkc-media-layout--left    (float left, text wraps right)
   *   right  → mkc-media-layout--right   (float right, text wraps left)
   * Note: margin is NOT set inline so CSS layout rules can control it cleanly.
   * Pre-664 videos without layout class retain their inline margin:8px auto.
   * Appends <p><br></p> so the user can continue typing after the video.
   */
  private wrapIframe(src: string): string {
    const size = (this.videoPanel && this.videoPanel.videoSize) || 'medium';
    const layout = (this.videoPanel && this.videoPanel.videoLayout) || 'center';
    const outerSizeClass = size === 'small' ? ' mkc-video-outer--small'
                         : size === 'large' ? ' mkc-video-outer--large'
                         : ' mkc-video-outer--medium';
    const layoutClass = ` mkc-media-layout mkc-media-layout--${layout}`;
    // (669) Two-wrapper structure fixes the Small/Medium/Large aspect ratio bug.
    //
    // ROOT CAUSE: padding-bottom:56.25% (the 16:9 ratio trick) is calculated from
    // the CONTAINING BLOCK's width (the parent element), not from the element's own
    // max-width-constrained width. When .mkc-video-wrapper--small (max-width:520px)
    // sits inside .mkc-media-block (full editor width, e.g. 700px), the ratio box
    // height = 56.25% of 700px = 393px instead of 56.25% of 520px = 293px.
    //
    // FIX: Separate concerns into two divs:
    //   .mkc-video-outer  — carries max-width + float/layout (float:left etc.)
    //   .mkc-video-wrapper — just the ratio box; width:100% of .mkc-video-outer,
    //                        so padding-bottom is now % of the constrained width. ✓
    //
    // .mkc-media-block (overflow:hidden = BFC) contains the floated .mkc-video-outer.
    // .mkc-media-helper-text (overflow:hidden = BFC) sits beside the float as a column.
    return (
      `<div class="mkc-media-block">` +
      `<div class="mkc-video-outer${outerSizeClass}${layoutClass}">` +
      `<div class="mkc-video-wrapper" style="position:relative;width:100%;` +
      `padding-bottom:56.25%;height:0;overflow:hidden;">` +
      `<iframe src="${src}" ` +
      `style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" ` +
      `frameborder="0" allowfullscreen ` +
      `allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture">` +
      `</iframe></div>` +
      `</div>` +
      this.mediaHelperHtml +
      `</div><p><br></p>`
    );
  }
}
